export function isActionContentObject(obj) {
  return obj && typeof obj === 'object';
}